<template>
  <div class="rate-setting" v-loading.fullscreen.lock="pageLoading">
    <div class="rate-block">
      <div class="chargingRate-block">
        <div class="title">
          <span>{{ $t('EvCharging.RateTable') }}</span>
        </div>
        <div class="content">
          <div class="header charging-table-row">
            <div>{{ $t('EvCharging.Classify') }}</div>
            <div>{{ $t('EvCharging.Mode') }}</div>
            <div>{{ $t('EvCharging.PriceMode') }}</div>
            <div>{{ $t('EvCharging.Action') }}</div>
          </div>
          <div class="data-row charging-table-row" :class="{ 'dashed' : summerChargingPrice.timeOfUsePrice }">
            <div>{{ $t('EvCharging.SummerRate') }}</div>
            <div>
              <span v-if="summerChargingPrice.timeOfUsePrice" class="already-set">{{ $t('EvCharging.TimeMode') }}</span>
              <span v-else-if="summerChargingPrice.fixedPrice" class="already-set">{{ $t('EvCharging.FixedMode') }}</span>
              <span v-else class="not-set">{{ $t('EvCharging.NotSet') }}</span>
            </div>
            <div>
              <div v-if="summerChargingPrice.timeOfUsePrice">
                <div class="price-div">
                  {{ $t('EvCharging.HightRate') }}：{{ summerChargingPrice.highPrice }} {{ $t('EvCharging.DollarKWHUnit') }}
                </div>
                <div class="time-table">
                  <div>{{ $t('EvCharging.HightTime') }}</div>
                  <div>
                    <template v-for="key in Object.keys(summerChargingPrice.timeOfUsePrice)">
                      <div v-if="summerChargingPrice.timeOfUsePrice[key].some((item) => item.Price === summerChargingPrice.highPrice)" class="week-time" :key="key">
                        <div class="week">{{ $t(`EvCharging.Every${key}`) }}</div>
                        <div>
                          <template v-for="(item, index) in summerChargingPrice.timeOfUsePrice[key]">
                            <div v-if="item.Price === summerChargingPrice.highPrice" :key="`nonSummer_${key}_${index}`">
                              {{ `${(item.BeginHour).toString().padStart(2, '0')}:00` }} - {{ `${(item.EndHour ).toString().padStart(2, '0')}:00`}}
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div v-else-if="summerChargingPrice.fixedPrice" class="price-div">
                {{ $t('EvCharging.FixedMode') }}：{{ summerChargingPrice.fixedPrice }} {{ $t('EvCharging.DollarKWHUnit') }}
              </div>
            </div>
            <div>
              <el-tooltip :disabled="loginUserInfo.IsAdmin" :content="$t('Auth.NotHighestAdmin')" placement="top">
                <el-button
                  size="mini"
                  plain
                  :disabled="!loginUserInfo.IsAdmin"
                  @click.stop="editChargingRate('summer')"
                >
                  {{ $t('General.Edit') }}
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div v-if="summerChargingPrice.timeOfUsePrice" class="data-row charging-table-row">
            <div></div>
            <div></div>
            <div>
              <div class="price-div">
                {{ $t('EvCharging.LowRate') }}：{{ summerChargingPrice.lowPrice }} {{ $t('EvCharging.DollarKWHUnit') }}
              </div>
            </div>
            <div></div>
          </div>
          <div class="data-row charging-table-row" :class="{ 'dashed' : nonSummerChargingPrice.timeOfUsePrice }">
            <div>{{ $t('EvCharging.NotSummerRate') }}</div>
            <div>
              <span v-if="nonSummerChargingPrice.timeOfUsePrice" class="already-set">{{ $t('EvCharging.TimeMode') }}</span>
              <span v-else-if="nonSummerChargingPrice.fixedPrice" class="already-set">{{ $t('EvCharging.FixedMode') }}</span>
              <span v-else class="not-set">{{ $t('EvCharging.NotSet') }}</span>
            </div>
            <div>
              <div v-if="nonSummerChargingPrice.timeOfUsePrice">
                <div class="price-div">
                  {{ $t('EvCharging.HightRate') }}：{{ nonSummerChargingPrice.highPrice }} {{ $t('EvCharging.DollarKWHUnit') }}
                </div>
                <div class="time-table">
                  <div>{{ $t('EvCharging.HightTime') }}</div>
                  <div>
                    <template v-for="key in Object.keys(nonSummerChargingPrice.timeOfUsePrice)">
                      <div v-if="nonSummerChargingPrice.timeOfUsePrice[key].some((item) => item.Price === nonSummerChargingPrice.highPrice)" class="week-time" :key="key">
                        <div class="week">{{ $t(`EvCharging.Every${key}`) }}</div>
                        <div>
                          <template v-for="(item, index) in nonSummerChargingPrice.timeOfUsePrice[key]">
                            <div v-if="item.Price === nonSummerChargingPrice.highPrice" :key="`nonSummer_${key}_${index}`">
                              {{ `${(item.BeginHour).toString().padStart(2, '0')}:00` }} - {{ `${(item.EndHour ).toString().padStart(2, '0')}:00`}}
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div v-else-if="nonSummerChargingPrice.fixedPrice" class="price-div">
                {{ $t('EvCharging.FixedMode') }}：{{ nonSummerChargingPrice.fixedPrice }} {{ $t('EvCharging.DollarKWHUnit') }}
              </div>
            </div>
            <div>
              <el-tooltip :disabled="loginUserInfo.IsAdmin" :content="$t('Auth.NotHighestAdmin')" placement="top">
                <el-button
                  size="mini"
                  plain
                  :disabled="!loginUserInfo.IsAdmin"
                  @click.stop="editChargingRate('notsummer')"
                >
                  {{ $t('General.Edit') }}
                </el-button>
              </el-tooltip>
            </div>
          </div>
          <div v-if="nonSummerChargingPrice.timeOfUsePrice" class="data-row charging-table-row">
            <div></div>
            <div></div>
            <div>
              <div class="price-div">
                {{ $t('EvCharging.LowRate') }}：{{ nonSummerChargingPrice.lowPrice }} {{ $t('EvCharging.DollarKWHUnit') }}
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <div class="parkingRate-block">
        <div class="title">
          <span>{{ $t('EvCharging.ParkingRateTable') }}</span>
        </div>
        <div class="illustrate">
          <div>{{ $t('EvCharging.PriceIllustrateTitle') }}：</div>
          <ul>
            <li>{{ $t('EvCharging.PriceIllustrate1') }}</li>
            <li>
              {{ $t('EvCharging.PriceIllustrate2') }}
              <ol>
                <li>{{ $t('EvCharging.PriceIllustrate3') }}</li>
                <li>{{ $t('EvCharging.PriceIllustrate4') }}</li>
              </ol>
            </li>
          </ul>
        </div>
        <div class="content">
          <el-table
            v-loading="loadingList"
            tooltip-effect="dark"
            :data="parkingRateData"
            style="width: 100%"
          >
            <el-table-column
              prop="Status"
              :label="$t('EvCharging.Status')"
              width="150"
            >
              <template slot-scope="scope">
                <div :class="scope.row.Status ? 'already-set' : 'not-set'">{{ scope.row.Status ? $t('EvCharging.Use') : $t('EvCharging.UnUse') }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="BufferMinutes"
              :label="$t('EvCharging.BufferTimeWithUnit')"
            >
              <template slot="header">
                <div class="center-header">{{ $t('EvCharging.BufferTimeWithUnit') }}</div>
              </template>
              <template slot-scope="scope">
                <div class="number" :class="{'disabled': !scope.row.Status}">{{ scope.row.BufferMinutes || '' }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="PriceUnitMinutes"
              :label="$t('EvCharging.PriceIllustrateWithUnit')"
            >
              <template slot="header">
                <div class="center-header">{{ $t('EvCharging.PriceIllustrateWithUnit') }}</div>
              </template>
              <template slot-scope="scope">
                <div class="number" :class="{'disabled': !scope.row.Status}">{{ scope.row.PriceUnitMinutes || '' }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="PricePerUnit"
              :label="$t('EvCharging.ParkingPriceWithUnit')"
            >
              <template slot="header">
                <div class="center-header">{{ $t('EvCharging.ParkingPriceWithUnit') }}</div>
              </template>
              <template slot-scope="scope">
                <div class="number" :class="{'disabled': !scope.row.Status}">{{ scope.row.PricePerUnit || '' }}</div>
              </template>
            </el-table-column>
            <el-table-column
              class-name="operation"
              :label="$t('EvCharging.Action')"
              width="150"
            >
              <template slot-scope="scope">
                <el-tooltip :disabled="loginUserInfo.IsAdmin" :content="$t('Auth.NotHighestAdmin')" placement="top">
                  <el-button
                    size="mini"
                    plain
                    :disabled="!loginUserInfo.IsAdmin"
                    @click.stop="editParkingRate(scope.row)"
                  >
                    {{ $t('General.Edit') }}
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="example">
          <div>
            {{ $t('EvCharging.Example1') }}
          </div>
          <div>
            {{ $t('EvCharging.Example2') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiEvCharging } from '@/api/EvCharging'

export default {
  data () {
    return {
      loadingList: false,
      pageLoading: true,
      summerChargingPrice: {
        fixedPrice: null,
        timeOfUsePrice: null,
        highPrice: null,
        lowPrice: null
      },
      nonSummerChargingPrice: {
        fixedPrice: null,
        timeOfUsePrice: null,
        highPrice: null,
        lowPrice: null
      },
      parkingRateData: [
        {
          Status: false,
          BufferMinutes: null,
          PriceUnitMinutes: null,
          PricePerUnit: null
        }
      ],
      rate: {
        chargingRate: {
          mode: 'timeRate',
          timeRatePrice: {
            high: 0,
            low: 0
          },
          fixedRatePrice: 5.5
        },
        parkingRate: {
          mode: '',
          price: {
            IdlePriceUnitMinutes: 0,
            IdlePricePerUnit: 0,
            IdleBufferMinutes: 0
          }
        }
      },
      settingPopup: false,
      formattedTimePeriodData: {},
      originSettingData: {},
      loginUserInfo: {}
    }
  },
  mounted () {
    this.getRateSetting()
    this.initLoginUserInfo()
  },
  methods: {
    async getRateSetting () {
      this.pageLoading = true
      apiEvCharging.RateSetting.getRateSetting().then(res => {
        if (res?.data?.Data?.Pricing) {
          this.formatResParkingRate(res.data.Data.Pricing.IdlePrice)
          this.formatResChargingRate(res.data.Data.Pricing.NonSummerChargingPrice, false)
          this.formatResChargingRate(res.data.Data.Pricing.SummerChargingPrice, true)
        }

        this.originSettingData = res.data.Data
        this.pageLoading = false
      }).catch(err => {
        console.log(err)
        this.pageLoading = false
      })
    },
    formatResChargingRate (chargingData, isSummer) {
      const key = isSummer ? 'summerChargingPrice' : 'nonSummerChargingPrice'
      this[key].fixedPrice = chargingData?.FixedPrice || null
      this[key].timeOfUsePrice = chargingData?.TimeOfUsePrice || null
      if (!chargingData || chargingData.FixedPrice) {
        this[key].highPrice = null
        this[key].lowPrice = null
      } else if (chargingData.TimeOfUsePrice) {
        let highPrice = 0
        let lowPrice = 0
        Object.values(chargingData.TimeOfUsePrice).forEach((item) => {
          item.forEach((item2) => {
            if (item2.Price > highPrice) {
              lowPrice = highPrice
              highPrice = item2.Price
            } else if (item2.Price < highPrice && item2.Price !== lowPrice) {
              lowPrice = item2.Price
            }
          })
        })
        this[key].highPrice = highPrice
        this[key].lowPrice = lowPrice
      }
    },
    formatResParkingRate (parkingData) {
      if (parkingData) {
        this.parkingRateData[0].Status = parkingData.Enabled
        this.parkingRateData[0].BufferMinutes = parkingData.IdleBufferMinutes
        this.parkingRateData[0].PriceUnitMinutes = parkingData.IdlePriceUnitMinutes
        this.parkingRateData[0].PricePerUnit = parkingData.IdlePricePerUnit
      } else {
        this.parkingRateData[0].Status = false
        this.parkingRateData[0].BufferMinutes = 0
        this.parkingRateData[0].PriceUnitMinutes = 0
        this.parkingRateData[0].PricePerUnit = 0
      }
    },

    // 將所有時段&費率格式化，將不同price的資料分開
    // 格式會大概為
    //  {
    //    '5'(=price): {
    //       Sunday: [[0, 12], [15, 18]], (= 0點~12點、15點~18點)
    //       Monday: [],
    //       ...
    //    },
    //    '8': {
    //       Sunday: ...
    //    }
    //  }
    formatResTimePeriod (timeOfUsePrice) {
      if (!timeOfUsePrice) return

      const formattedData = {}
      for (const [key, value] of Object.entries(timeOfUsePrice)) {
        // key: 星期
        // value: 時段陣列資料

        value.forEach(o => {
          if (typeof o.Price === 'number') { // 避免怪資料，只保留是數字的資料
            // 還沒有建置的話先初始化
            if (!formattedData[o.Price]) formattedData[o.Price] = {}
            if (!formattedData[o.Price][key]) formattedData[o.Price][key] = []

            formattedData[o.Price][key].push([o.BeginHour, o.EndHour])
          }
        })
      }
      this.formattedTimePeriodData = formattedData
    },
    formatResTimeRateHighAndLow () { // 先獨立處理 感覺比較乾淨，再看要不要從formatResTimePeriod拿price陣列資料就好
      if (!this.formattedTimePeriodData) return
      const priceArray = []
      for (const price of Object.keys(this.formattedTimePeriodData)) {
        priceArray.push(+price)
      }
      priceArray.sort((a, b) => b - a) // 降冪排序
      this.rate.chargingRate.timeRatePrice.high = priceArray[0] || 0
      this.rate.chargingRate.timeRatePrice.low = priceArray[1] || priceArray[0] // 如果只有一個費率，避免出事所以補上資料
    },
    clickTimeRangeSave (timeRangeData) { // 會是一個{formattedWeekActive, formattedWeekInactive}的物件，須分別設定尖離峰價格
      const { formattedWeekActive, formattedWeekInactive } = timeRangeData
      const priceLow = this.rate.chargingRate.timeRatePrice.low
      const priceHigh = this.rate.chargingRate.timeRatePrice.high
      const formatWholeWeek = {}
      for (const [key, value] of Object.entries(formattedWeekActive)) {
        if (!formatWholeWeek[key]) formatWholeWeek[key] = []
        value.forEach(timeRange => {
          formatWholeWeek[key].push({
            BeginHour: timeRange[0] || 0,
            EndHour: timeRange[1] || 0,
            Price: priceHigh
          })
        })
      }
      for (const [key, value] of Object.entries(formattedWeekInactive)) {
        if (!formatWholeWeek[key]) formatWholeWeek[key] = []
        value.forEach(timeRange => {
          formatWholeWeek[key].push({
            BeginHour: timeRange[0] || 0,
            EndHour: timeRange[1] || 0,
            Price: priceLow
          })
        })
      }

      const settingParams = _cloneDeep(this.originSettingData)
      settingParams.Pricing.ChargingPrice.TimeOfUsePrice = formatWholeWeek
      const { _UpdateTime: UpdateTime, ...params } = settingParams
      apiEvCharging.RateSetting.putRateSetting(params).then(res => {
        this.getRateSetting()
      }).catch(err => {
        console.log(err)
      })
    },
    editChargingRate (data) {
      this.$router.push({ name: 'chargingRateSetting', params: { summer: data } })
    },
    editParkingRate (data) {
      this.$router.push({ name: 'parkingRateSetting' })
    },
    initLoginUserInfo () {
      this.loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
    }
  }
}
</script>

<style lang="scss" scoped>
.rate-setting {
  .rate-block {
    .chargingRate-block,
    .parkingRate-block {
      width: 100%;
      text-align: left;

      .title {
        font-size: map-get($fontSize, large);
        font-weight: bold;
        color: $mainFontColor;
        padding-block: 24px;
      }
      .illustrate {
        line-height: 1.5pc;
        margin-top: 8px;
        color: $subFontColor;
        font-size: map-get($fontSize, small);
        ul, ol {
          padding-inline-start: 20px;
        }
        ul {
          margin-top: 4px;
          li {
            list-style: disc;
          }
        }
        ol {
          li {
            list-style: decimal;
          }
        }
      }
      .content {
        .charging-table-row {
          width: 100%;
          display: flex;
          padding-block: 10px;
          &.header {
            font-size: map-get($fontSize, small);
            font-weight: bold;
            color: $mainFontColor;
            background-color: $bgDarkBg;
            border-bottom: 1px solid $lightFontColor;
          }
          &.data-row {
            border-bottom: 1px solid $lightFontColor;
            & > div:nth-child(1),
            & > div:nth-child(2),
            & > div:nth-child(3) {
              padding-block: 9px;
            }
          }
          &.dashed {
            border-style: none;
            position: relative;
            &::before {
              position: absolute;
              bottom: 0;
              content: '';
              width: 100%;
              height: 1px;
              background-image: linear-gradient(to right, $lightFontColor 0%, $lightFontColor 50%, transparent 50%);
              background-size: 20px 1px;
              background-repeat: repeat-x;
            }
          }
          & > div {
            padding-inline: 10px;
          }
          & > div:nth-child(1) {
            min-width: 260px;
          }
          & > div:nth-child(2) {
            min-width: 130px;
          }
          & > div:nth-child(3) {
            width: 100%;
          }
          & > div:nth-child(4) {
            min-width: 130px;
          }
          .price-div {
            font-size: map-get($fontSize, large);
            font-weight: 600;
            color: $mainFontColor;
          }
          .time-table {
            display: flex;
            margin-top: 16px;
            color: $subFontColor;
            & > div:nth-child(2) {
              margin-left: 36px;
            }
            .week {
              color: $mainFontColor;
            }
            .week-time {
              display: flex;
              margin-bottom: 12px;
              & > div:nth-child(2) {
                margin-left: 32px;
              }
            }
          }
        }
        ::v-deep .el-table {
          @include basicTable;
          .colored {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &.color-success {
              color: $mainColor;
            }
            &.color-danger {
              color: $dangerColor;
            }
          }
          .multiLines {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .not-set {
          color: $dangerColor;
        }
        .already-set {
          color: $successColor;
        }
      }
      .example {
        margin: 16px;
        padding: 10px 16px;
        color: $mainFontColor;
        font-size: map-get($fontSize, small);
        line-height: 1.3pc;
        background-color: $bgDark3;
      }
    }
    .parkingRate-block {
      .title {
        margin-top: 55px;
      }
      .content {
        .center-header {
          text-align: center;
        }
        .number {
          font-size: map-get($fontSize, large);
          font-weight: bold;
          text-align: center;
        }
        .disabled {
          color: $grayFontColor;
        }
      }
    }
  }

  .timeSetting-block {
    &__header {
      text-align: start;
      padding-left: 26px;
      padding-bottom: 27px;
      .title {
        font-size: map-get($fontSize, large);
        font-weight: 600;
        margin-bottom: 10px;
      }
      .tip {
        font-size: map-get($fontSize, small);
        color: $subFontColor;
      }
    }
  }
}
</style>
